(function () {
  var TAB_NAME = 'hoosier-tire';
  var HS_SITES_HOST = '51464965.hs-sites.com';
  var STORE_HOST_SUFFIX = 'hoosiertire.com';

  function hostMatches(hostname) {
    if (hostname === HS_SITES_HOST) return true;
    if (hostname === STORE_HOST_SUFFIX) return true;
    if (hostname.slice(-(STORE_HOST_SUFFIX.length + 1)) === '.' + STORE_HOST_SUFFIX) return true;
    return false;
  }

  function matchesTarget(href) {
    try {
      var url = new URL(href, window.location.href);
      return hostMatches(url.hostname);
    } catch (e) {
      return false;
    }
  }

  function applyTarget(link) {
    if (matchesTarget(link.href)) {
      link.target = TAB_NAME;
    }
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches('a[href]')) applyTarget(root);
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) applyTarget(links[i]);
  }

  scan(document.documentElement);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        scan(added[j]);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (link) applyTarget(link);
  });
})();
